import {
  BrowserClient,
  browserTracingIntegration,
  defaultStackParser,
  getDefaultIntegrations,
  makeFetchTransport,
  Scope,
} from "@sentry/react";
import { environmentFromUrl } from "../../api";
import { version } from "../../../package.json";

const devMode = import.meta.env.DEV;

// filter integrations that use the global variable
const integrations = getDefaultIntegrations({}).filter((defaultIntegration) => {
  return !["BrowserApiErrors", "Breadcrumbs", "GlobalHandlers"].includes(defaultIntegration.name);
});

let sentryScope: Scope | null = null;

export function initSentry() {
  const client = new BrowserClient({
    dsn: `https://c700f6e0612d8d546ac9a0b13c7b47f0@sentry.dev.jobrad.org/11`,
    environment: environmentFromUrl(window?.location?.hostname, devMode),
    release: version,
    enabled: !devMode,
    tracesSampleRate: devMode ? 1.0 : 0.2,
    stackParser: defaultStackParser,
    transport: makeFetchTransport,
    integrations: [...integrations, browserTracingIntegration()],
  });
  sentryScope = new Scope();
  sentryScope.setClient(client);
  client.init();
}

export function getSentryScope() {
  return sentryScope;
}
